import { SkeletonText } from '@neshane/blueberry';

export const KYCFileSkeleton = () => {
    return (
        <div className="w-full">
            <SkeletonText size="xxl" />
        </div>
    );
};